<form [formGroup]="form">
  <span><b>Usuário</b></span>
  <div class="flex flex-col gap-3 mt-3 mb-3 w-3on12 md-w-5on12 sm-w-full">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Nome</mat-label>
      <input matInput type="text" formControlName="name" />
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>E-mail</mat-label>
      <input matInput type="text" formControlName="email" />
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Contatos</mat-label>
      <input matInput type="text" formControlName="phones" />
    </mat-form-field>
  </div>

  <span><b>Empresa</b></span>
  <div class="flex flex-col gap-3 mt-3 mb-3 w-3on12 md-w-5on12 sm-w-full">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Empresa</mat-label>
      <mat-select placeholder="Selecione o status" formControlName="type">
        <mat-option value="MICHELIN">Michelin</mat-option>
        <mat-option value="AUTOMAKER">Montadora (OE)</mat-option>
        <mat-option value="DISTRIBUTOR">Distribuidor Exclusivo (DE)</mat-option>
      </mat-select>
    </mat-form-field>

    @if (type.value === 'AUTOMAKER') {
      <app-select-form-field
        label="Montadora (OE)"
        [control]="company"
        [options]="data.automakers"
        [display]="companyDisplayName"
        />
    }

    @if (type.value === 'DISTRIBUTOR') {
      <app-select-form-field
        label="Distribuidor Exclusivo (DE)"
        [control]="company"
        [options]="data.distributors"
        [display]="companyDisplayName"
        />
    }

    <app-select-form-field
      label="Perfil de Acesso"
      [control]="userProfile"
      [options]="profilesByType"
      [display]="profileDisplayName"
      />
    </div>

    <span><b>Senha</b></span>
    <div class="flex flex-col gap-3 mt-3 mb-3 w-3on12 md-w-5on12 sm-w-full">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Senha</mat-label>
        <input matInput type="password" formControlName="password" />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Confirmar Senha</mat-label>
        <input matInput type="password" formControlName="passwordConfirm" />
      </mat-form-field>
    </div>

    <div class="mt-3">
      <div class="flex flex-row mt-3 gap-4">
        <mat-checkbox formControlName="enabled">Ativo</mat-checkbox>
      </div>
    </div>
  </form>
